export default __webpack_public_path__ + "static/9-84e6174fbd5cbf48784f9ac295e3ee36.webp";